/**
 * Wear by Anaya — match product-card gallery arrows to PDP chevrons
 */
(function () {
  var PREV_SVG =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var NEXT_SVG =
    '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function syncArrows(root) {
    var scope = root || document;
    scope.querySelectorAll(
      '.card-gallery .slideshow-control--previous, .product-card .slideshow-control--previous, product-card .slideshow-control--previous, .product-recommendations .slideshow-control--previous, .resource-list .slideshow-control--previous'
    ).forEach(function (btn) {
      if (btn.dataset.anayaArrow === 'true') return;
      btn.dataset.anayaArrow = 'true';
      btn.classList.remove('flip-x');
      btn.innerHTML = PREV_SVG;
    });

    scope.querySelectorAll(
      '.card-gallery .slideshow-control--next, .product-card .slideshow-control--next, product-card .slideshow-control--next, .product-recommendations .slideshow-control--next, .resource-list .slideshow-control--next'
    ).forEach(function (btn) {
      if (btn.dataset.anayaArrow === 'true') return;
      btn.dataset.anayaArrow = 'true';
      btn.classList.remove('flip-x');
      btn.innerHTML = NEXT_SVG;
    });
  }

  function boot() {
    syncArrows(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);

  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          syncArrows(document);
          break;
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
